import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "./";
import { GET_MEDIA_URL } from "../../config/webService";
import { currentLanguage, navigationWithEvents, truncateText } from "../../util/common";
import { useAppNavigation } from "../../hooks";
import AppointmentTypeModal from "./AppointmentTypeModal";

const Card = ({ type, title, image, route, customClassName, service, isCAD }) => {
  const { t } = useTranslation();
  const { localeRoutes, toUrl, toUrlWithData } = useAppNavigation();
  const [showAppointmentTypeModal, setShowAppointmentTypeModal] = useState(false);

  const language = currentLanguage();
  const defaultClassName = customClassName || `col-md-6 col-lg-4 col-xl-3`;
  const LocaleHeading = () => <h3>{truncateText(title?.["value_" + language], 50)}</h3>;

  const handleNavigation = () => {
    if (isCAD) {
      setShowAppointmentTypeModal(true);
    } else {
      toUrlWithData(localeRoutes.appointment[language], { service });
    }
  };
  return (
    <div className={defaultClassName}>
      <div
        className="service-card"
        style={{
          background: `url(${GET_MEDIA_URL + (image?.[language] || image)})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat"
        }}>
        <div className="offer-meta">
          <LocaleHeading />
          <div className="card-navs">
            {service ? (
              <Button type="blue-roundedRight" action={handleNavigation}>
                {t("services.book")}
              </Button>
            ) : (
              <Button
                type="blue-roundedRight"
                action={() =>
                  navigationWithEvents(
                    type === "offers" ? "Header-Kaizen" : "Header-Services",
                    type === "offers" ? "Kaizen Details" : "Services Details",
                    () => toUrl(route)
                  )
                }>
                {type === "offers" ? t("offer.seeMore") : t("services.seeMore")}
              </Button>
            )}
          </div>
        </div>
        {showAppointmentTypeModal && isCAD && (
          <AppointmentTypeModal
            {...{
              show: showAppointmentTypeModal,
              onCancel: () => setShowAppointmentTypeModal(false),
              offerId: service?.id,
              from: "select-services"
            }}
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(Card);
